module.exports = __webpack_public_path__ + "static/media/avatar.7a63e221.svg";